import { Injectable, inject } from "@angular/core";
import { StompRouterService } from "@app/services/webstomp/stomp-router.service";
import { BehaviorSubject } from "rxjs";
import { EntityChangeEvent } from "@app/services/webstomp/entity-change-event";

@Injectable({
  providedIn: "root"
})
export class WebStompEntitySubscriber {
  private stompRouter = inject(StompRouterService);

  public subscribeToEntity(entity: string): BehaviorSubject<EntityChangeEvent> {
    let _entitySubject: BehaviorSubject<EntityChangeEvent> =
      new BehaviorSubject(null);
    this.stompRouter.addSubscription("/topic/" + entity);
    this.stompRouter.getEntityStream(entity).subscribe((changeEvent) => {
      _entitySubject.next(changeEvent);
    });
    return _entitySubject;
  }
}
